import { ChevronDownIcon, EditIcon } from '@chakra-ui/icons';
import { Badge, Box, Flex, Heading, Menu, MenuButton, MenuItem, MenuList, Stack, Text, useColorModeValue } from '@chakra-ui/react';
import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { DataContext } from '../../../../state/DataContext/DataContext';
import { DeleteJobBtn } from '../DeleteJobBtn/DeleteJobBtn';
import EditJobBtn from '../JobForm/EditJob/EditJobBtn';


export const JobCard = (props) => {
    const { data, actions } = React.useContext(DataContext);

    let gray = useColorModeValue("gray.600", "gray.400");
    let { tenantID } = useParams<any>();
    const setJob = (job) => {
        actions.Job.SetCurrentJob(job);
    }

    return <Stack
        px={8}
        py={4}
        boxShadow={props.noShadow ? "none" : "md"}
        bg={"white"}
        borderRadius="md"
    // _hover={{
    //     bg: "gray.100",
    // }}
    // _focus={{
    //     bg: "gray.100",
    // }}
    >

        <Flex >
            <Text color={gray}
            >
                {/* TODO: check active by date */}
                {/* Active */}
            </Text>


            <Box marginLeft="auto">
                {/* If i set this to right, it will expand screen on mobile */}
                <Menu placement="bottom-start">
                    <MenuButton as={Text}
                        padding="0 0.5em"
                        borderRadius="0.2em"
                        cursor="pointer"
                        _hover={{
                            bg: "green.400",
                        }}
                        fontSize="0.8em" bg="green.500" fontWeight="semibold" color="white"
                    >
                        Actions <ChevronDownIcon />
                    </MenuButton>
                    <MenuList >
                        <Link to={`/${tenantID}/admin/jobs/${props.job.ID}`} onClick={() => setJob(props.job)}> <MenuItem >Edit Checklist</MenuItem>
                        </Link>

                        <EditJobBtn
                            job={props.job}
                            afterEditFn={props.onClose}
                            renderBtn={() => {
                                return <>
                                    <MenuItem onClick={() => {
                                        actions.setPathFrom("jobcard");
                                    }}>
                                        <EditIcon mr="1" />
                                        Edit Job
                                    </MenuItem>
                                </>
                            }}
                        />

                        <DeleteJobBtn
                            TenantID={tenantID}
                            JobID={props.job.ID}
                            afterDeleteFn={props.onClose}

                        />
                    </MenuList>
                </Menu>
            </Box>
        </Flex>



        <Heading color={gray}
            size="md" textTransform="capitalize">
            {props.job.Title} for {props.job.CustomerName}
        </Heading>
        <Flex>
            <Box mr="2">
                <Text fontWeight="bold">Assigned to:</Text>
            </Box>
            <Box>
                {props.job.AssignedTo?.map((assignedTo, index) => {
                    return <Badge mr="2" borderRadius="md" colorScheme="green" key={`${props.job.ID}+${index}`}>{assignedTo?.Name}</Badge>
                })}
                {!props.job.AssignedTo && <Badge mr="2" borderRadius="md" colorScheme="gray" >Not Assigned</Badge>}
            </Box>
        </Flex>
    </Stack >
}
